import BaseModel from './BaseModel';

class ComplaintCategory extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.updateData(data)
  }

  updateData = (data) => {
    this.id = data.id;
    this.name = data.name || "";
    this.inactive = data.inactive || false;
    this.parent_category_id = data.parent_category_id || "";
    this.description = data.description || "";
  }

  toApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      category: {
        name: this.name,
        inactive: this.inactive,
        parent_id: this.parent_category_id,
        description: this.description,
      }
    }
  }

  validations = (field) => {
    return {
      name: () => {
        if(this[field] === "") {
          this.errors.name = "This field is required.";
        } else{
          delete this.errors.name;
        }
      },
    }[field];
  }

  validate = (field) => {
    if(this.validations(field)) {
      this.validations(field)()
    }
  }

}

export default ComplaintCategory;
